export default {
	isEmpty: () => true,
	isApplyStyleSystemClassesOnWrapperDiv: true,
};
